
import Vue from 'vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { cpf } from 'cpf-cnpj-validator';
import { createReportTerm, CreateReportTermParams } from '@/services/territory/create-report-term';
import Modal from '@/components/Modal/index.vue';
import Input from '@/components/Input/index.vue';
import Button from '@/components/Button/index.vue';

export default Vue.extend({
  inject: ['userLogged', 'getStepDate'],
  components: {
    Modal,
    Input,
    Button,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    onSubmitRepresentive: {
      type: Function,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isContestion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      validated: false,
    };
  },
  methods: {
    onNextStep() {
      this.validateInputs();
      if (this.validated) {
        this.createReportTermRequest();
        this.$emit('ReportTermCreated', this.getStepDate.term);
        if (this.isContestion === false) {
          this.getStepDate.currentStep += 1;
        } else {
          this.$router.push('/produtor/territory');
        }
      }
    },
    createReportTermRequest() {
      const {
        stName, stDocument, stEmail, stPhone,
      } = this.userLogged;
      const strAdress = `${this.getStepDate.address.address}, ${this.getStepDate.address.neighborhood}`;
      const params: CreateReportTermParams = {
        nameMain: stName,
        document: stDocument,
        tokenKey: this.userLogged.company.stKey,
        cdTerritory: this.getStepDate.territory.id,
        carNumber: this.getStepDate.territory.car.replaceAll('-', ''),
        territoryName: this.getStepDate.territory.name,
        street: strAdress,
        number: this.getStepDate.address.number,
        complement: this.getStepDate.address.complement,
        city: this.getStepDate.address.city,
        state: this.getStepDate.address.state,
        cep: this.getStepDate.address.zipCode,
        email: stEmail,
        telephone: stPhone,
        cdAgent: this.getStepDate.agent.id,
        representativeName: this.getStepDate.territory.representative.name,
        representativeDocumentNumber: this.getStepDate.territory.representative.document,
        representativePosition: this.getStepDate.territory.representative.office,
        isAssing: false,
      };
      createReportTerm(params).then((data) => {
        this.getStepDate.term = { ...this.getStepDate.term, ...data };
      });
    },
    onNextStepNotAccepted() {
      this.getStepDate.territory.representative.name = 'Não informado';
      this.getStepDate.territory.representative.document = '0';
      this.getStepDate.territory.representative.office = 'Não informado';
      this.createReportTermRequest();
      this.$emit('ReportTermCreated', this.getStepDate.term);
      if (this.isContestion === false) {
        this.getStepDate.currentStep += 1;
      } else {
        this.$router.push('/produtor/territory');
      }
    },
    validateInputs() {
      if (
        this.getStepDate.territory.representative.name
        && this.getStepDate.territory.representative.document
        && this.getStepDate.territory.representative.office
      ) {
        const isCpfValid = cpf.isValid(this.getStepDate.territory.representative.document);
        if (!isCpfValid) return;
        this.validated = true;
      }
    },
    removeNumbers(value) {
      return value.replace(/^[0-9]+$/, '');
    },
    removeSpecialCharacters(charactersString) {
      return charactersString.replace(/[^\w\s]/, '');
    },
    checkForSpecialCharacters(charactersString) {
      const specialCharactersRegex = /[^\w\s]/;
      return specialCharactersRegex.test(charactersString);
    },
    checkForSpecialCharactersNumber(charactersString) {
      const specialCharactersRegex = /^[0-9]/;
      return specialCharactersRegex.test(charactersString);
    },
  },
  watch: {
    'getStepDate.territory.representative.office': function office(newValue) {
      if (this.checkForSpecialCharacters(newValue)) {
        this.getStepDate.territory.representative.office = '';
      }
      if (this.checkForSpecialCharactersNumber(newValue)) {
        this.getStepDate.territory.representative.office = '';
      }
      this.removeSpecialCharacters(newValue);
      this.removeNumbers(newValue);
    },
    'getStepDate.territory.representative.name': function dateCaracters(newValue) {
      if (this.checkForSpecialCharacters(newValue)) {
        this.getStepDate.territory.representative.name = '';
      }
      if (this.checkForSpecialCharactersNumber(newValue)) {
        this.getStepDate.territory.representative.name = '';
      }
      this.removeSpecialCharacters(newValue);
      this.removeNumbers(newValue);
    },
  },
});
